import { ProductTag } from "@/entities/productTag"

export const EffyPackage = {
    PILOTAGE_PAC: "PILOTAGE_PAC",
    CONFORT_SMALL: "CONFORT_SMALL",
    CONFORT_MEDIUM: "CONFORT_MEDIUM",
    CONFORT_LARGE: "CONFORT_LARGE",
} as const

export type EffyPackage = (typeof EffyPackage)[keyof typeof EffyPackage]

export const EffyPackageAmounts = {
    [EffyPackage.PILOTAGE_PAC]: 0,
    [EffyPackage.CONFORT_SMALL]: 3999,
    [EffyPackage.CONFORT_MEDIUM]: 7499,
    [EffyPackage.CONFORT_LARGE]: 10999,
}

// Short names for the package selection toggle
export const EFFY_PACKAGE_LABELS: Record<EffyPackage, string> = {
    [EffyPackage.PILOTAGE_PAC]: "Electricité + Pilotage PAC",
    [EffyPackage.CONFORT_SMALL]: "Confort Small",
    [EffyPackage.CONFORT_MEDIUM]: "Confort Medium",
    [EffyPackage.CONFORT_LARGE]: "Confort Large",
}

// Full "Pack" names for the price breakdown of the chosen package
export const EFFY_PACKAGE_PACK_LABELS: Record<EffyPackage, string> = {
    [EffyPackage.PILOTAGE_PAC]: "Electricité + Pilotage PAC",
    [EffyPackage.CONFORT_SMALL]: "Confort Pack Small",
    [EffyPackage.CONFORT_MEDIUM]: "Confort Pack Medium",
    [EffyPackage.CONFORT_LARGE]: "Confort Pack Large",
}

export const EFFY_PACKAGE_MAX_CONSUMPTION_MWH: Record<EffyPackage, number | null> = {
    [EffyPackage.PILOTAGE_PAC]: null,
    [EffyPackage.CONFORT_SMALL]: 3,
    [EffyPackage.CONFORT_MEDIUM]: 5,
    [EffyPackage.CONFORT_LARGE]: 7,
}

export const EFFY_PACKAGE_PRODUCT_TAGS: Record<EffyPackage, ProductTag> = {
    [EffyPackage.PILOTAGE_PAC]: ProductTag.EFFY_PILOTAGE_PAC,
    [EffyPackage.CONFORT_SMALL]: ProductTag.EFFY_CONFORT_SMALL,
    [EffyPackage.CONFORT_MEDIUM]: ProductTag.EFFY_CONFORT_MEDIUM,
    [EffyPackage.CONFORT_LARGE]: ProductTag.EFFY_CONFORT_LARGE,
}
